import { render } from "./BookViewFaq.vue?vue&type=template&id=367735a7&scoped=true"
import script from "./BookViewFaq.vue?vue&type=script&lang=js"
export * from "./BookViewFaq.vue?vue&type=script&lang=js"

import "./BookViewFaq.vue?vue&type=style&index=0&id=367735a7&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-367735a7"

export default script